import React from 'react';
import { Autocomplete } from '@material-ui/lab';
import { TextField, TextFieldProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { WrappedFieldProps } from 'redux-form';

export interface EditableSelectControlProps {
    items: string[];
    // Optional
    label?: string;
    name?: string;
    onChange?: (value: string[]) => void;
    value?: string[];
    error?: string;
    autoFocus?: boolean;
}

const useInputStyles = makeStyles(theme => ({
    root: {
        borderRadius: theme.spacing(0.75),
    },
}));

const useLabelStyles = makeStyles({
    root: {
        transform: 'translate(12px, 16px)',
    },
});

export const EditableSelectControl = (props: EditableSelectControlProps) => {
    const inputClasses = useInputStyles();
    const labelClasses = useLabelStyles();
    const autocompleteProps: any = {
        multiple: false,
        freeSolo: true,
        options: props.items,
        autoSelect: true,
    };
    return (
        <Autocomplete
            {...autocompleteProps}
            onChange={props.onChange && ((_, v) => props.onChange(v as any))}
            value={props.value}
            renderInput={(params: TextFieldProps) => {
                return (
                    <TextField
                        {...params}
                        InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,
                            classes: inputClasses,
                        }}
                        InputLabelProps={{
                            ...params.InputLabelProps,
                            classes: labelClasses,
                        }}
                        size="small"
                        label={props.label}
                        variant="filled"
                        error={!!props.error}
                        helperText={props.error}
                        autoFocus={props.autoFocus}
                    />
                );
            }}
        />
    );
};

export interface EditableSelectControlFieldOwnProps {
    label: string;
    items: string[];
    // Optional:
    autoFocus?: boolean;
}

export type EditableSelectControlFieldProps = EditableSelectControlFieldOwnProps & WrappedFieldProps;

export const EditableSelectControlField = (props: EditableSelectControlFieldProps) => {
    const {
        input,
        label,
        items,
        autoFocus,
        meta: { touched, invalid, error },
    } = props;
    return (
        <EditableSelectControl
            label={label}
            items={items}
            error={touched && invalid ? error : undefined}
            autoFocus={autoFocus}
            {...input}
        />
    );
};
